import { useEffect } from "react";

const DEFAULT_TITLE = "Tracre One | AI Powered Real Estate CRM";
const DEFAULT_DESCRIPTION =
  "Tracre One is the smart Android CRM for real estate agents, brokers & property consultants. Automate WhatsApp follow-ups with AI, manage your sales pipeline, and grow your business 10x.";

export const useDocumentMeta = (title, description) => {
  useEffect(() => {
    document.title = title;

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description);

    window.scrollTo(0, 0);

    return () => {
      document.title = DEFAULT_TITLE;
      meta.setAttribute("content", DEFAULT_DESCRIPTION);
    };
  }, [title, description]);
};
